import { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import config from '@/config';
import ProfileDataContext from '@/context/ProfileDataContext';
import useCache from '@/hooks/useCache';
import ProfileAddButton from '@/shared-components/buttons/components/ProfileAddButton';
import CreateNewArtlist from '@/shared-components/forms/components/CreateNewArtlist';
import ProfileContentLoader from '@/shared-components/loader/special-loaders/ProfileContentLoader';
import Text from '@/shared-components/text/components/Text';

import MetaDescripProfilePages from '../MetaDescripProfilePages';

import ArtlistsVirtualList from './components/ArtlistsVirtualList';

import './index.css';

export default function ProfileArtlists() {
  const { profileData, internal } = useContext(ProfileDataContext);
  const { loading, fetchData, loadMoreData } = useCache(
    `${profileData._id}_artlists`,
    `${config.apis.api.url}/artlist/user/${profileData._id}`,
    {
      injectToken: true,
      invalidateWhen: internal
        ? [
          "NEW_ARTLIST",
          "EDIT_ARTLIST",
          "DELETE_ARTLIST",
          "ADD_TO_ARTLIST",
          "ADD_TO_ARTLIST_FROM_ARTWORK",
          "REMOVE_FROM_ARTLIST",
          `${profileData._id}_REFRESH`,
        ]
        : [`${profileData._id}_REFRESH`],
    }
  );
  const [openCreateArtlist, setOpenCreateArtlist] = useState(false);
  const navigate = useNavigate();

  function onCreateNewArtlist(newArtlist) {
    navigate(`/artlist/${newArtlist._id}`, {
      state: { from: true },
    });
  }

  return (
    <>
      <MetaDescripProfilePages fetchData={profileData} subPage="artlists" />
      {internal && (
        <>
          <ProfileAddButton onClick={() => setOpenCreateArtlist(true)} />
          <CreateNewArtlist
            open={openCreateArtlist}
            close={() => setOpenCreateArtlist(false)}
            onCreateNewArtlist={onCreateNewArtlist}
          />
        </>
      )}

      {loading ? (
        <ProfileContentLoader className="profile-artlists__artlists-spinner" />
      ) : fetchData.data.length === 0 ? (
        <Text className="user-profile__artlists-empty-view" paragraph small>
          {internal ? (
            profileData.user_type === "gallery" ? (
              "Categorize your artworks into custom lists, enriching the curation and presentation of your gallery's offerings."
            ) : (
              "Be a curator! Create new artlists and share your tastes."
            )
          ) : (
            "There are no artlists available at the moment. Stay tuned for future additions."
          )}
        </Text>
      ) : (
        <ArtlistsVirtualList items={fetchData} onLoadMore={loadMoreData} />
      )}
    </>
  );
}
